const selectVoterRegistrationStatusOptions = [
  { id: 1, name: 'Regular', enum: 'REGULAR', color: 'status-ok' },
  { id: 2, name: 'Irregular', enum: 'IRREGULAR', color: 'status-warning' },
  { id: 3, name: 'Outro domicílio eleitoral', enum: 'OTHER_CITY', color: 'status-error' },
];

export default selectVoterRegistrationStatusOptions;
